import React from 'react';
import Partners from '../screens/Partners';
import Partnership from '../screens/Partnership';
import Products from '../screens/Partnership/Products';
import Settings from '../screens/Settings';
import Shopify from '../screens/Shopify';
import Payouts from '../screens/Payouts';
import Orders from '../screens/Orders';
import Reports from '../screens/Reports';
import Discover from '../screens/Discover';
import User from '../screens/Discover/user';

export default [
    {
        path: '/discover',
        screen: (props) => <Discover {...props} />,
        exact: true
    },
    {
        path: '/discover/:id',
        screen: (props) => <User {...props} />,
        exact: true
    },
    {
        path: '/reports',
        screen: (props) => <Reports {...props} />,
        exact: true
    },
    {
        path: '/partners',
        screen: (props) => <Partners {...props} />,
        exact: true
    },
    {
        path: '/payouts',
        screen: (props) => <Payouts {...props} />,
        exact: true
    },
    {
        path: '/orders',
        screen: (props) => <Orders {...props} />,
        exact: true
    },
    {
        path: '/partnership/:id',
        screen: (props) => <Partnership {...props} />,
        exact: true
    },
    {
        path: '/partnership/:id/products',
        screen: (props) => <Products {...props} />,
        exact: true
    },
    {
        path: '/settings',
        screen: (props) => <Settings {...props} />,
        exact: true
    },
    {
        path: '/shopify',
        screen: (props) => <Shopify {...props} />,
        exact: true
    }
]